import configData from "./config.json";

/** Map Vite `--mode` to a key in `config.json` (local | prod; test for Playwright). */
function resolveAppEnv(viteMode) {
  if (viteMode === "production") return "prod";
  if (viteMode === "test") return "test";
  return "local";
}

const modeKey = resolveAppEnv(import.meta.env.MODE);
const envConfig = configData[modeKey] || configData.local;

export const baseUrl = envConfig.API_BASE_URL;
export const s3baseUrl = envConfig.S3_BASE_URL;
export const appBaseUrl = envConfig.APP_BASE_URL;
export const projectMode = envConfig.PROJECT_MODE;

export const xsAuthClientId = envConfig.XS_AUTH_CLIENT_ID;
export const xsAuthUrl = envConfig.XS_AUTH_URL;
export const xsAuthBootstrapUrl = envConfig.XS_AUTH_BOOTSTRAP_URL;
export const xsAccountUrl = envConfig.XS_ACCOUNT_URL;
